/* src/app/shared/components/paginate/paginate.component.scss */
.paginate .btn:not(.disabled):hover {
  color: #fff;
  border: 1px solid #111111;
  background-color: #585858;
  background:
    linear-gradient(
      to bottom,
      #585858 0%,
      #111111 100%);
}
.paginate .btn:not(.disabled).current {
  color: #333333;
  border: 1px solid #979797;
  background-color: white;
  background:
    linear-gradient(
      to bottom,
      white 0%,
      gainsboro 100%);
}
/*# sourceMappingURL=paginate.component-23WWZ77L.css.map */
